import React from 'react';
import moment from 'moment';
import { Tooltip } from 'antd';

const CustomDate = ({ date }) => {
  return (
    date &&
    <Tooltip title={moment(date).format('MM/DD/YYYY hh:mm:ss')}>
      <div>{moment(date).format('MM/DD/YYYY')}</div>
    </Tooltip>
  )
}

export default CustomDate;